/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ElektronischeZustellungKontaktDto } from '../models/elektronische-zustellung-kontakt-dto';
import { employeeControllerCreate } from '../fn/employee/employee-controller-create';
import { EmployeeControllerCreate$Params } from '../fn/employee/employee-controller-create';
import { employeeControllerDelete } from '../fn/employee/employee-controller-delete';
import { EmployeeControllerDelete$Params } from '../fn/employee/employee-controller-delete';
import { employeeControllerFindAll } from '../fn/employee/employee-controller-find-all';
import { EmployeeControllerFindAll$Params } from '../fn/employee/employee-controller-find-all';
import { employeeControllerFindAllDropdown } from '../fn/employee/employee-controller-find-all-dropdown';
import { EmployeeControllerFindAllDropdown$Params } from '../fn/employee/employee-controller-find-all-dropdown';
import { employeeControllerFindOne } from '../fn/employee/employee-controller-find-one';
import { EmployeeControllerFindOne$Params } from '../fn/employee/employee-controller-find-one';
import { employeeControllerGetAllEmployees } from '../fn/employee/employee-controller-get-all-employees';
import { EmployeeControllerGetAllEmployees$Params } from '../fn/employee/employee-controller-get-all-employees';
import { employeeControllerGetMultipleEmployeeEmails } from '../fn/employee/employee-controller-get-multiple-employee-emails';
import { EmployeeControllerGetMultipleEmployeeEmails$Params } from '../fn/employee/employee-controller-get-multiple-employee-emails';
import { employeeControllerGetMultipleEmployeeEmailsPhones } from '../fn/employee/employee-controller-get-multiple-employee-emails-phones';
import { EmployeeControllerGetMultipleEmployeeEmailsPhones$Params } from '../fn/employee/employee-controller-get-multiple-employee-emails-phones';
import { employeeControllerRestore } from '../fn/employee/employee-controller-restore';
import { EmployeeControllerRestore$Params } from '../fn/employee/employee-controller-restore';
import { employeeControllerUpdate } from '../fn/employee/employee-controller-update';
import { EmployeeControllerUpdate$Params } from '../fn/employee/employee-controller-update';
import { EmployeeDto } from '../models/employee-dto';
import { EmployeeEmailDto } from '../models/employee-email-dto';
import { EmployeeListItemDto } from '../models/employee-list-item-dto';
import { EmployeeNameDto } from '../models/employee-name-dto';
import { NameDto } from '../models/name-dto';
import { PaginatedDto } from '../models/paginated-dto';

@Injectable({ providedIn: 'root' })
export class EmployeeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `employeeControllerFindAll()` */
  static readonly EmployeeControllerFindAllPath = '/api/employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerFindAll$Response(params: EmployeeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<EmployeeListItemDto>;
}>> {
    const obs = employeeControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerFindAll(params: EmployeeControllerFindAll$Params, context?: HttpContext): Observable<PaginatedDto & {
'items'?: Array<EmployeeListItemDto>;
}> {
    const resp = this.employeeControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedDto & {
'items'?: Array<EmployeeListItemDto>;
}>): PaginatedDto & {
'items'?: Array<EmployeeListItemDto>;
} => r.body)
    );
  }

  /** Path part for operation `employeeControllerCreate()` */
  static readonly EmployeeControllerCreatePath = '/api/employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  employeeControllerCreate$Response(params: EmployeeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeDto>> {
    const obs = employeeControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  employeeControllerCreate(params: EmployeeControllerCreate$Params, context?: HttpContext): Observable<EmployeeDto> {
    const resp = this.employeeControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmployeeDto>): EmployeeDto => r.body)
    );
  }

  /** Path part for operation `employeeControllerUpdate()` */
  static readonly EmployeeControllerUpdatePath = '/api/employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  employeeControllerUpdate$Response(params: EmployeeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeDto>> {
    const obs = employeeControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  employeeControllerUpdate(params: EmployeeControllerUpdate$Params, context?: HttpContext): Observable<EmployeeDto> {
    const resp = this.employeeControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmployeeDto>): EmployeeDto => r.body)
    );
  }

  /** Path part for operation `employeeControllerFindAllDropdown()` */
  static readonly EmployeeControllerFindAllDropdownPath = '/api/employee/dropdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerFindAllDropdown()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerFindAllDropdown$Response(params: EmployeeControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
    const obs = employeeControllerFindAllDropdown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerFindAllDropdown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerFindAllDropdown(params: EmployeeControllerFindAllDropdown$Params, context?: HttpContext): Observable<Array<NameDto>> {
    const resp = this.employeeControllerFindAllDropdown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<NameDto>>): Array<NameDto> => r.body)
    );
  }

  /** Path part for operation `employeeControllerGetAllEmployees()` */
  static readonly EmployeeControllerGetAllEmployeesPath = '/api/employee/employee-names';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerGetAllEmployees()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerGetAllEmployees$Response(params: EmployeeControllerGetAllEmployees$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeNameDto>>> {
    const obs = employeeControllerGetAllEmployees(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerGetAllEmployees$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerGetAllEmployees(params: EmployeeControllerGetAllEmployees$Params, context?: HttpContext): Observable<Array<EmployeeNameDto>> {
    const resp = this.employeeControllerGetAllEmployees$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<EmployeeNameDto>>): Array<EmployeeNameDto> => r.body)
    );
  }

  /** Path part for operation `employeeControllerGetMultipleEmployeeEmails()` */
  static readonly EmployeeControllerGetMultipleEmployeeEmailsPath = '/api/employee/employee-emails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerGetMultipleEmployeeEmails()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerGetMultipleEmployeeEmails$Response(params: EmployeeControllerGetMultipleEmployeeEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeEmailDto>>> {
    const obs = employeeControllerGetMultipleEmployeeEmails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerGetMultipleEmployeeEmails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerGetMultipleEmployeeEmails(params: EmployeeControllerGetMultipleEmployeeEmails$Params, context?: HttpContext): Observable<Array<EmployeeEmailDto>> {
    const resp = this.employeeControllerGetMultipleEmployeeEmails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<EmployeeEmailDto>>): Array<EmployeeEmailDto> => r.body)
    );
  }

  /** Path part for operation `employeeControllerGetMultipleEmployeeEmailsPhones()` */
  static readonly EmployeeControllerGetMultipleEmployeeEmailsPhonesPath = '/api/employee/employee-email-phone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerGetMultipleEmployeeEmailsPhones()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerGetMultipleEmployeeEmailsPhones$Response(params: EmployeeControllerGetMultipleEmployeeEmailsPhones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ElektronischeZustellungKontaktDto>>> {
    const obs = employeeControllerGetMultipleEmployeeEmailsPhones(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerGetMultipleEmployeeEmailsPhones$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerGetMultipleEmployeeEmailsPhones(params: EmployeeControllerGetMultipleEmployeeEmailsPhones$Params, context?: HttpContext): Observable<Array<ElektronischeZustellungKontaktDto>> {
    const resp = this.employeeControllerGetMultipleEmployeeEmailsPhones$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ElektronischeZustellungKontaktDto>>): Array<ElektronischeZustellungKontaktDto> => r.body)
    );
  }

  /** Path part for operation `employeeControllerFindOne()` */
  static readonly EmployeeControllerFindOnePath = '/api/employee/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerFindOne$Response(params: EmployeeControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeDto>> {
    const obs = employeeControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerFindOne(params: EmployeeControllerFindOne$Params, context?: HttpContext): Observable<EmployeeDto> {
    const resp = this.employeeControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmployeeDto>): EmployeeDto => r.body)
    );
  }

  /** Path part for operation `employeeControllerDelete()` */
  static readonly EmployeeControllerDeletePath = '/api/employee/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerDelete$Response(params: EmployeeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = employeeControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerDelete(params: EmployeeControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.employeeControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `employeeControllerRestore()` */
  static readonly EmployeeControllerRestorePath = '/api/employee/restore/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerRestore$Response(params: EmployeeControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = employeeControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employeeControllerRestore(params: EmployeeControllerRestore$Params, context?: HttpContext): Observable<void> {
    const resp = this.employeeControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
